import { encryptJsonWithRawKeyCBC, decryptJsonWithRawKeyCBC } from '../utils/crypto'

var websock = null;
let rec; //断线重连后，延迟5秒重新创建WebSocket连接  rec用来存储延迟请求的代码
let isConnect = false; //连接标识 避免重复连接
let connectCallBack = null;
let messageCallBack = null;
let closeCallBack = null;

// WebSocket AES 加密密钥 (hex 格式)
const AES_KEY = process.env.VUE_APP_AES_KEY || "";
let sessionRawKey = null; // hex 字符串 - 固定 AES 密钥，为空则不加密

// 初始化固定 AES 密钥
if (AES_KEY && AES_KEY.length > 0) {
	sessionRawKey = AES_KEY;
}

// 消息处理函数（支持递归调用处理解密后的消息）
let processMessage = (data) => {
	let sendInfo = JSON.parse(data);

	// 处理加密消息（仅当启用加密时才解密）
	if (sessionRawKey && sendInfo.enc && (sendInfo.enc.startsWith('aes-gcm') || sendInfo.enc.startsWith('aes-cbc')) && sendInfo.data) {
		(async () => {
			try {
				const inner = await decryptJsonWithRawKeyCBC(sessionRawKey, sendInfo.data);
				processMessage(JSON.stringify(inner));
			} catch (e) {
				console.error('decrypt message failed', e);
			}
		})();
		return;
	}

	if (sendInfo.cmd == 0) {
		// 登录成功响应
		heartCheck.start();
		// 登录成功才算真正完成连接
		connectCallBack && connectCallBack();
		console.log('WebSocket登录成功');
	} else if (sendInfo.cmd == 1) {
		// 重新开启心跳定时
		heartCheck.reset();
	} else {
		// 其他消息转发出去
		console.log("收到消息:", sendInfo);
		messageCallBack && messageCallBack(sendInfo.cmd, sendInfo.data);
	}
};

let connect = (wsurl, accessToken) => {
	try {
		if (isConnect) {
			return;
		}
		console.log("连接WebSocket");
		websock = new WebSocket(wsurl);
		websock.onmessage = function (e) {
			processMessage(e.data);
		};
		websock.onclose = function (e) {
			console.log('WebSocket连接关闭');
			isConnect = false; //断开后修改标识
			closeCallBack && closeCallBack(e);
		};
		websock.onopen = function () {
			console.log("WebSocket连接成功");
			isConnect = true;
			// 发送登录消息（如果启用加密则加密发送，否则明文发送）
			(async () => {
				try {
					let loginInfo = {
						cmd: 0,
						data: {
							accessToken: accessToken
						}
					};
					if (sessionRawKey) {
						// 加密发送（encryptJsonWithRawKeyCBC 已返回完整加密格式）
						const encrypted = await encryptJsonWithRawKeyCBC(sessionRawKey, loginInfo);
						websock.send(JSON.stringify(encrypted));
					} else {
						// 明文发送
						websock.send(JSON.stringify(loginInfo));
					}
				} catch (e) {
					console.error('发送登录消息失败', e);
				}
			})();
		};

		// 连接发生错误的回调方法
		websock.onerror = function (e) {
			console.log('WebSocket连接发生错误: ', e);
			close(3000);
			isConnect = false;
			closeCallBack && closeCallBack(e);
		};
	} catch (e) {
		console.log("尝试创建连接失败");
		reconnect(wsurl, accessToken); //如果无法连接上webSocket 那么重新连接！可能会因为服务器重新部署，或者短暂断网等导致无法创建连接
	}
};

//定义重连函数
let reconnect = (wsurl, accessToken) => {
	console.log("尝试重新连接");
	if (isConnect) {
		//如果已经连上就不在重连了
		return;
	}
	rec && clearTimeout(rec);
	rec = setTimeout(function () { // 延迟15秒重连  避免过多次过频繁请求重连
		connect(wsurl, accessToken);
	}, 15000);
};

//设置关闭连接
let close = (code) => {
	if (!isConnect) {
		return;
	}
	websock && websock.close(code);
};


//心跳设置
let heartCheck = {
	timeout: 20000, //每段时间发送一次心跳包 这里设置为20s
	timeoutObj: null, //延时发送消息对象（启动心跳新建这个对象，收到消息后重置对象）
	start: function () {
		if (isConnect) {
			console.log('发送WebSocket心跳');
			let heartBeat = {
				cmd: 1,
				data: {}
			};
			// 心跳消息也需要加密（如果启用了加密）
			if (sessionRawKey) {
				(async () => {
					try {
						const encrypted = await encryptJsonWithRawKeyCBC(sessionRawKey, heartBeat);
						websock.send(JSON.stringify(encrypted));
					} catch (e) {
						console.error('发送加密心跳失败', e);
					}
				})();
			} else {
				websock.send(JSON.stringify(heartBeat));
			}
		}
	},

	reset: function () {
		clearTimeout(this.timeoutObj);
		this.timeoutObj = setTimeout(function () {
			heartCheck.start();
		}, this.timeout);

	}
};



// 实际调用的方法
let sendMessage = (agentData) => {
	(async () => {
		try {
			let payload = typeof agentData === 'string' ? agentData : JSON.stringify(agentData);
			if (sessionRawKey) {
				// 加密发送
				const obj = typeof agentData === 'string' ? JSON.parse(agentData) : agentData;
				const encrypted = await encryptJsonWithRawKeyCBC(sessionRawKey, obj);
				websock.send(JSON.stringify(encrypted));
			} else {
				// 明文发送
				websock.send(payload);
			}
		} catch (e) {
			console.error('sendMessage error', e);
		}
	})();
};

let onConnect = (callback) => {
	connectCallBack = callback;
};

let onMessage = (callback) => {
	messageCallBack = callback;
};

let onClose = (callback) => {
	closeCallBack = callback;
};

// 将方法暴露出去
export {
	connect,
	reconnect,
	close,
	sendMessage,
	onConnect,
	onMessage,
	onClose,
};